module.exports = __webpack_public_path__ + "148d970ffdc35bf793f19cc8d787ef70.jpg";